export const removeSubscriptionIdFromText = (text = '') => text.replaceAll(/A-S[0-9]{8}/g, 'A-S********');
